<template>
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <circle cx="16" cy="16" r="16" :fill="circleColor" stroke="none" />
    <path d="M16 28C9.37259 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4" :stroke="secundaryColor" stroke-width="1.2" stroke-linecap="round" stroke-dasharray="2.5 2.5"/>
    <path d="M16 4C22.6274 4 28 9.37258 28 16C28 22.6274 22.6274 28 16 28" :stroke="circleLineColor" stroke-width="1.2" stroke-linecap="round"/>
    <path d="M11.5479 21.6903V10.8569H20.2145V21.6903" :stroke="color" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 22L21.7619 22" :stroke="color" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.1484 13.9521H14.7675" :stroke="color" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16.9346 13.9521H17.5536" :stroke="color" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.1484 16.4287H14.7675" :stroke="color" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16.9346 16.4287H17.5536" :stroke="color" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.334 21.6905V18.9048H17.4292V21.6905" :stroke="color" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12.4766 10.5476V9H15.5718V10.5476" :stroke="color" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#3D5DFC',
            required: false
        },
        secundaryColor: {
            type: String,
            default: '#CAD3FF',
            required: false
        },
        circleColor: {
            type: String,
            default: '#E7EBFF',
            required: false
        },
        circleLineColor: {
            type: String,
            default: '#6D85FD',
            required: false
        }

    }
}
</script>